module.exports = __webpack_public_path__ + "img/home-what-is.9f3cb18.png";